import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const Paid = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Paid";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
